import { t } from "i18next"

import type { UserAccountFormState } from "../../shared/types"

export const DEFAULT_FORM: UserAccountFormState = {
  password: "",
  password_confirmation: "",
  current_password: ""
}

export const REQUIRED_VALIDATION_TEXTS_MAP: Record<
  Exclude<
    keyof UserAccountFormState,
    | "interface_language"
    | "agent_workspace_display_layout"
    | "translate_to_language"
    | "translate_from_languages"
    | "transcript_translation_enabled"
    | "available_languages"
    | "is_transcript_translation_enabled"
  >,
  string
> = {
  current_password: t("userProfile_userProfileSidePanel_password_noCurrentPassword"),
  password: t("userProfile_userProfileSidePanel_password_noNewPassword"),
  password_confirmation: t("userProfile_userProfileSidePanel_password_notPasswordConfirm")
}
